import axios from "axios";
import { toast } from "react-toastify";
import { store } from "..";
import { Axios, baseUrl } from "./Axios";
import { clear } from "./Storage";
import { isAfter, isBefore } from "date-fns";
import { isEqual } from "lodash";
import { calculateBundleOffer } from "./CartService";


// console.log('REACT_APP_BASE_URL =', baseUrl);
// console.log('Axios baseURL =', Axios.defaults?.baseURL);
export const fetchConfig = async () => {
  return await Axios.get("/v1/config", { responseType: "json" });
};
export const fetchTimeSlot = async (date, type, orderType, p_id, p_date) => {
  const zone = sessionStorage.getItem("zone");
  return await Axios.get(
    `/time-slots/list/${zone}/${date}/${type}/${orderType}${
      p_id && p_date ? `?p_id=${p_id}&p_date=${p_date}` : ""
    }`
  );
};
export const fetchOrderFrequency = async () => {
  return await Axios.get("/v2/order-frequency");
};
export const fetchAddresses = async () => {
  return await Axios.get("/v1/customer/address/list", { responseType: "json" });
};
export const deleteAddress = async (addressId) => {
  return await Axios.post(
    `/v1/customer/address/delete?address_id=${addressId}`,
    {
      _method: "delete",
    },
    { responseType: "json" }
  );
};
export const fetchAreas = async () => {
  return await Axios.get("/laundry-areas/get-areas", { responseType: "json" });
};
export const addAddress = async (payload) => {
  const token = localStorage.getItem("token");
  return axios.post("/api/v1/customer/address/add", payload, {
    responseType: "json",
    baseURL: baseUrl,
    headers: {
      moduleid: "",
      storeType: "laundry",
      Laundryzoneid: payload.laundryZoneId,
      Zoneid: payload.zoneId,
      Authorization: `Bearer ${token}`,
    },
  });
};
export const updateAddress = async (payload) => {
  const token = localStorage.getItem("token");
  return axios.put(`/api/v1/customer/address/update/${payload.id}`, payload, {
    responseType: "json",
    baseURL: baseUrl,
    headers: {
      moduleid: "",
      storeType: "laundry",
      Laundryzoneid: payload.laundryZoneId,
      Zoneid: payload.zoneId,
      Authorization: `Bearer ${token}`,
    },
  });
};
export const fetchCustomerInfo = async () => {
  return await Axios.get("/v1/customer/info", { responseType: "json" });
};
export const updateCustomer = async (payload) => {
  return await Axios.post("/v1/customer/update-profile", payload, {
    responseType: "json",
  });
};
export const fetchNotifications = async ({ limit = 10, offset = 1 }) => {
  return Axios.get(
    `/customer/laundry/get-notifications?limit=${limit}&offset=${offset}`
  );
};
export const submitReview = async (payload) => {
  return Axios.post("/customer/reviews/submit", payload);
};
export const ChangeEmailStatus = async (payload) => {
  return Axios.post("/customer/email/status", payload);
};
export const walletRetrieve = async () => {
  return await Axios.get(`/funds/retrieve`, { responseType: "json" });
};
export const fetchMyReferrals = async () => {
  return await Axios.get("/v1/customer/referrals", { responseType: "json" });
};
export const createCustNote = async (note) => {
  const res = await Axios.post("v1/customer/note", { note });
  return res;
};
export const updateCustNote = async (id, note) => {
  const res = await Axios.put(`/v1/customer/note/${id}`, { note });
  return res;
};
export const deleteCustNote = async (id) => {
  return await Axios.delete(`/v1/customer/note/${id}`, );
};
export const logout = () => {
  const c = store.getState().Config;
  store.dispatch({ type: "setToken", payload: null });
  store.dispatch({ type: "setOrderType", payload: null });
  store.dispatch({ type: "setService", payload: null });
  store.dispatch({ type: "setCategory", payload: null });
  store.dispatch({ type: "setCart", payload: [] });
  store.dispatch({ type: "setLoggedIn", payload: false });
  store.dispatch({ type: "setZone", payload: null });
  store.dispatch({ type: "setCustomer", payload: null });
  store.dispatch({ type: "setAddress", payload: null });
  store.dispatch({ type: "setAddresses", payload: null });
  store.dispatch({ type: "setOngoingOrders", payload: null });
  store.dispatch({ type: "setNote", payload: null });
  store.dispatch({ type: "setPickupDate", payload: null });
  store.dispatch({ type: "setDeliveryDate", payload: null });
  store.dispatch({ type: "setCoupon", payload: null });
  clear();
  store.dispatch({ type: "setConfig", payload: c });
  window.history.replaceState({}, "", process.env.PUBLIC_URL + "/app");
  toast.dismiss();
  setTimeout(() => {
    toast.dismiss();
    toast.error("Session Expired! Please login again...");
  }, 300);
};

export const isDateBetween = (date, startDate, endDate) => {
  return (
    (isAfter(date, startDate) && isBefore(date, endDate)) ||
    isEqual(date, startDate) ||
    isEqual(date, endDate)
  );
};
export const transformOrderDetailItems = (data) => {
  const record = [];
  let open = {};
  let count = 0;
  let items_price = 0;

  data.forEach((entry) => {
    const serviceId = entry.service.id;
    open = {
      ...open,
      [serviceId]: true,
    };
    const existingService = record.find(
      (service) => service.services_id === serviceId
    );
    const is_bundle_active = Boolean(entry.is_bundle_active);
    const item = {
      laundry_item_id: entry.laundry_item.id,
      price: entry.price,
      quantity: entry.quantity,
      name: entry.laundry_item.name,
      is_bundle_active,
      item_note: entry.item_note,
      free_items: is_bundle_active
        ? calculateBundleOffer({
            bundleBuy: entry.bundle_buy,
            bundleFree: entry.bundle_free,
            itemPrice: entry.price,
            totalQuantity: entry.quantity,
          }).freeItems
        : 0,
      addons: [],
    };
    if (entry.laundry_item.id) {
      count += entry.quantity;
      items_price += item.price * (item.quantity - item.free_items);
    }
    if (existingService) {
      existingService.items.push(item);
    } else {
      record.push({
        services_id: serviceId,
        service: entry.service.name,
        open: true,
        items: [item],
      });
    }
  });

  return { count, open, record, items_price };
};
